module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._l((_vm.practitioners), function(practitioner) {
    return [_vm._t("default"), _vm._v(" "), (practitioner) ? _c('v-tooltip', {
      key: practitioner.id,
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-avatar', _vm._g({
            staticClass: "ml-1 elevation-4",
            attrs: {
              "size": _vm.size,
              "color": "grey"
            }
          }, on), [(_vm.avatarUrl(practitioner)) ? _c('v-img', {
            attrs: {
              "lazy": "",
              "src": _vm.avatarUrl(practitioner)
            }
          }) : _c('span', {
            staticClass: "white--text"
          }, [(practitioner && practitioner.full_name) ? [_vm._v("\n              " + _vm._s(practitioner.full_name[0]) + "\n            ")] : _vm._e()], 2)], 1), _vm._v(" "), (_vm.withAdd) ? _c('v-chip', {
            attrs: {
              "outline": "",
              "outlined": "",
              "color": "primary",
              "size": _vm.size
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.$emit("add")
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("add")])], 1) : _vm._e()]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getTitle(practitioner)))])]) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-042faf53","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lists/PractitionerFaces.vue
// module id = 1312
// module chunks = 9